/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Casmanagement_Table_Emptystate_Title2Inputs */

const en_settings_casmanagement_table_emptystate_title2 = /** @type {(inputs: Settings_Casmanagement_Table_Emptystate_Title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No CAS templates found`)
};

/**
* | output |
* | --- |
* | "No CAS templates found" |
*
* @param {Settings_Casmanagement_Table_Emptystate_Title2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_casmanagement_table_emptystate_title2 = /** @type {((inputs?: Settings_Casmanagement_Table_Emptystate_Title2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Casmanagement_Table_Emptystate_Title2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_casmanagement_table_emptystate_title2(inputs)
});
export { settings_casmanagement_table_emptystate_title2 as "settings_casManagement_table_emptyState_title" }